import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const [isOpen, setIsOpen] = useState(true); // State to handle the toggle of the navbar
  const location = useLocation(); // Hook to get the current route

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  // Determine if the current route is active
  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div
        style={{
          height: "100vh",
          width: isOpen ? "250px" : "50px",
          background: "white",
          color: "black",
          transition: "width 0.3s",
          overflow: "hidden",
        }}
        
      >
        <div
          style={{
            cursor: "pointer",
            padding: isOpen ? "20px" : "20px",
            display: "flex",
            alignItems: "start",
            justifyContent: "start",
          }}
          onClick={toggleNavbar}
        >
          {isOpen ? (
            <i className="fa fa-bars" aria-hidden="true"></i>
          ) : (
            <i className="fa fa-bars" aria-hidden="true"></i>
          )}
        </div>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          <li className={isActive("/admindashboard") ? "hidden" : ""}>
            <Link  className="py-4 px-3">
              <i className="fa fa-home" aria-hidden="true"></i>
              {isOpen && <span className="ms-3">Dashboard</span>}
            </Link>
          </li>
          <li className={isActive("/contents") ? "hidden" : ""}>
            <Link className="py-4 px-3 d-flex">
              <i className="fa fa-edit" aria-hidden="true"></i>
              {isOpen && (
                <p className="mb-0 ms-3 d-flex justify-content-between w-100">
                  <span className="pb-1">Content</span>
                  <Link to="#">
                    <i className="fa-solid fa-plus"></i>
                  </Link>
                </p>
              )}
            </Link>
          </li>
          <li className={isActive("/membermanagement") ? "hidden" : ""}>
            <Link className="py-4 px-3">
              <i className="fa fa-users" aria-hidden="true"></i>
              {isOpen && <span className="ms-3">Members</span>}
            </Link>
          </li>
          {/* More items */}
        </ul>
      </div>
    </>
  );
}

export default Navbar;
